import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, stagger, item } from "@/components/site/Reveal";
import { CITIES, waLink, onWhatsApp } from "@/lib/site";

export const Areas = () => {
  return (
    <section id="areas" className="relative py-24 md:py-32 bg-surface border-y border-white/10">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Áreas Atendidas</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Guincho em Jundiaí e Região
          </h2>
          <p className="mt-5 text-lg text-zinc-400">
            A DG Guinchos atende Jundiaí e diversas cidades da região, oferecendo serviço de
            guincho e transporte de veículos 24 horas.
          </p>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {CITIES.map((c) => (
            <motion.a
              key={c.id}
              variants={item}
              href={waLink(`Preciso de guincho em ${c.name}.`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`area-${c.id}`}
              onClick={() => onWhatsApp(`area-${c.name}`)}
              className="group relative bg-ink border border-white/10 hover:border-brand rounded-sm p-6 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                  <MapPin className="h-5 w-5 text-brand" />
                  <h3 className="font-display text-2xl font-bold text-white">Guincho em {c.name}</h3>
                </div>
                <ArrowUpRight className="h-5 w-5 text-zinc-500 group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{c.text}</p>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
